import _noop from 'lodash/noop';
import '@dbh/generic-types';
import PropTypes from 'prop-types';
import 'react-immutable-proptypes';
import '@dbh/admindev-types';
import '@dbh/back-end-cdn-image-url-prop-type';
import '@dbh/date-fns-prop-types';
import '@dbh/countries-types';
import '@dbh/div-with-background';
import '@dbh/loyalty-types';

/*
 *
 * Constants: `@dbh/hotels-types`.
 *
 */const TAX_TYPES={INCLUSIVE:"Inclusive",EXCLUSIVE:"Exclusive"};const TAX_TYPES_VALUES=Object.values(TAX_TYPES);const TAX_AMOUNT_TYPES={PERCENT:"Percent",FIX:"Fix"};const TAX_AMOUNT_TYPES_VALUES=Object.values(TAX_AMOUNT_TYPES);const TAX_CHARGE_TYPES={PER_ROOM_PER_NIGHT:"PerRoomPerNight",PER_PERSON_PER_NIGHT:"PerPersonPerNight"};const TAX_CHARGE_TYPES_VALUES=Object.values(TAX_CHARGE_TYPES);

const taxTypePropType=_noop;var taxTypePropType$1 = taxTypePropType;

const taxAmountTypePropType=_noop;var taxAmountTypePropType$1 = taxAmountTypePropType;

const taxChargeTypeTypePropType=_noop;var taxChargeTypeTypePropType$1 = taxChargeTypeTypePropType;

const taxItemImmutablePropType=_noop;var taxItemImmutablePropType$1 = taxItemImmutablePropType;

// of API: `/bookings` and API: `/shoppingcarts`.
const bookingAttributesShape={};var bookingAttributesShape$1 = bookingAttributesShape;

// key: `reservations` and in API: `/shoppingcarts`, key: `items` and in API:
// POST `hotels`, key: `packages`.
const bookingAttributesShapeItem={};var bookingAttributesShapeItem$1 = bookingAttributesShapeItem;

const bookingAttributesImmutablePropType=_noop;var bookingAttributesImmutablePropType$1 = bookingAttributesImmutablePropType;

const cancellationInfoShape={};var cancellationInfoShape$1 = cancellationInfoShape;

const cancellationInfoImmutablePropType=_noop;var cancellationInfoImmutablePropType$1 = cancellationInfoImmutablePropType;

const locationShape={};var locationShape$1 = locationShape;

const locationImmutablePropType=_noop;var locationImmutablePropType$1 = locationImmutablePropType;

const hotelRatingPropType={};var hotelRatingPropType$1 = hotelRatingPropType;

const reviewShape={};var reviewShape$1 = reviewShape;

const reviewImmutablePropType=_noop;var reviewImmutablePropType$1 = reviewImmutablePropType;

const hotelImageImmutablePropType=_noop;var hotelImageImmutablePropType$1 = hotelImageImmutablePropType;

const hotelImagesListImmutablePropType=_noop;var hotelImagesListImmutablePropType$1 = hotelImagesListImmutablePropType;

const serviceImmutablePropType=_noop;var serviceImmutablePropType$1 = serviceImmutablePropType;

const macroCategoryShape={id:PropTypes.number.isRequired,name:PropTypes.string.isRequired,reference:PropTypes.string.isRequired};var macroCategoryShape$1 = macroCategoryShape;

const macroCategoryImmutablePropType=_noop;var macroCategoryImmutablePropType$1 = macroCategoryImmutablePropType;

const legacyPackageCategoryShape={};var legacyPackageCategoryShape$1 = legacyPackageCategoryShape;

const legacyPackageCategoryImmutablePropType=_noop;var legacyPackageCategoryImmutablePropType$1 = legacyPackageCategoryImmutablePropType;

const packageCategoryShape={};var packageCategoryShape$1 = packageCategoryShape;

const packageCategoryImmutablePropType=_noop;var packageCategoryImmutablePropType$1 = packageCategoryImmutablePropType;

const packageCategoriesImmutablePropType=_noop;var packageCategoriesImmutablePropType$1 = packageCategoriesImmutablePropType;

const listOfServicesImmutablePropType=_noop;var listOfServicesImmutablePropType$1 = listOfServicesImmutablePropType;

const packageAttributesShape={};var packageAttributesShape$1 = packageAttributesShape;

const packageAttributesImmutablePropType=_noop;var packageAttributesImmutablePropType$1 = packageAttributesImmutablePropType;

const pricesShape={};var pricesShape$1 = pricesShape;

const pricesImmutablePropType=_noop;var pricesImmutablePropType$1 = pricesImmutablePropType;

const packageShape={};var packageShape$1 = packageShape;

const packageImmutablePropType=_noop;var packageImmutablePropType$1 = packageImmutablePropType;

const hotelMarketingFlagImmutablePropType=_noop;var hotelMarketingFlagImmutablePropType$1 = hotelMarketingFlagImmutablePropType;

const hotelShape={};var hotelShape$1 = hotelShape;

const hotelImmutablePropType=_noop;var hotelImmutablePropType$1 = hotelImmutablePropType;

const hotelDetailsApiResponseImmutablePropType=_noop;var hotelDetailsApiResponseImmutablePropType$1 = hotelDetailsApiResponseImmutablePropType;

const hotelImagePropType=_noop;var hotelImagePropType$1 = hotelImagePropType;

const hotelListImmutablePropType=_noop;var hotelListImmutablePropType$1 = hotelListImmutablePropType;

const hotelMarkerShape={};var hotelMarkerShape$1 = hotelMarkerShape;

const hotelMarkerImmutablePropType=_noop;var hotelMarkerImmutablePropType$1 = hotelMarkerImmutablePropType;

const hotelPOSTImmutablePropType=_noop;var hotelPOSTImmutablePropType$1 = hotelPOSTImmutablePropType;

const hotelPackagesRequestOptionsPropType=_noop;var hotelPackagesRequestOptionsPropType$1 = hotelPackagesRequestOptionsPropType;

const postHotelsApiResponseItemsImmutablePropType=_noop;var postHotelsApiResponseItemsImmutablePropType$1 = postHotelsApiResponseItemsImmutablePropType;

const imageOrHotelImagePropType=_noop;var imageOrHotelImagePropType$1 = imageOrHotelImagePropType;

const listOfHotelMarkersImmutablePropType=_noop;var listOfHotelMarkersImmutablePropType$1 = listOfHotelMarkersImmutablePropType;

const listOfMapCoordinatesImmutablePropType=_noop;var listOfMapCoordinatesImmutablePropType$1 = listOfMapCoordinatesImmutablePropType;

const reservationItemShape={};var reservationItemShape$1 = reservationItemShape;

const reservationItemImmutablePropType=_noop;var reservationItemImmutablePropType$1 = reservationItemImmutablePropType;

const listReservationItemImmutablePropType=_noop;var listReservationItemImmutablePropType$1 = listReservationItemImmutablePropType;

const locationPropType=_noop;var locationPropType$1 = locationPropType;

const loyaltyImmutablePropType=_noop;var loyaltyImmutablePropType$1 = loyaltyImmutablePropType;

const mapLocationDataImmutablePropType=_noop;var mapLocationDataImmutablePropType$1 = mapLocationDataImmutablePropType;

const packageCategoryPropType=_noop;var packageCategoryPropType$1 = packageCategoryPropType;

const packageListImmutablePropType=_noop;var packageListImmutablePropType$1 = packageListImmutablePropType;

const packagesGroupShape={};var packagesGroupShape$1 = packagesGroupShape;

const packagesGroupImmutablePropType=_noop;var packagesGroupImmutablePropType$1 = packagesGroupImmutablePropType;

const pricesPropType=_noop;var pricesPropType$1 = pricesPropType;

export { TAX_AMOUNT_TYPES, TAX_AMOUNT_TYPES_VALUES, TAX_CHARGE_TYPES, TAX_CHARGE_TYPES_VALUES, TAX_TYPES, TAX_TYPES_VALUES, bookingAttributesImmutablePropType$1 as bookingAttributesImmutablePropType, bookingAttributesShape$1 as bookingAttributesShape, bookingAttributesShapeItem$1 as bookingAttributesShapeItem, cancellationInfoImmutablePropType$1 as cancellationInfoImmutablePropType, cancellationInfoShape$1 as cancellationInfoShape, hotelDetailsApiResponseImmutablePropType$1 as hotelDetailsApiResponseImmutablePropType, hotelImageImmutablePropType$1 as hotelImageImmutablePropType, hotelImagePropType$1 as hotelImagePropType, hotelImagesListImmutablePropType$1 as hotelImagesListImmutablePropType, hotelImmutablePropType$1 as hotelImmutablePropType, hotelListImmutablePropType$1 as hotelListImmutablePropType, hotelMarkerImmutablePropType$1 as hotelMarkerImmutablePropType, hotelMarkerShape$1 as hotelMarkerShape, hotelMarketingFlagImmutablePropType$1 as hotelMarketingFlagImmutablePropType, hotelPOSTImmutablePropType$1 as hotelPOSTImmutablePropType, hotelPackagesRequestOptionsPropType$1 as hotelPackagesRequestOptionsPropType, hotelRatingPropType$1 as hotelRatingPropType, hotelShape$1 as hotelShape, imageOrHotelImagePropType$1 as imageOrHotelImagePropType, legacyPackageCategoryImmutablePropType$1 as legacyPackageCategoryImmutablePropType, legacyPackageCategoryShape$1 as legacyPackageCategoryShape, listOfHotelMarkersImmutablePropType$1 as listOfHotelMarkersImmutablePropType, listOfMapCoordinatesImmutablePropType$1 as listOfMapCoordinatesImmutablePropType, listOfServicesImmutablePropType$1 as listOfServicesImmutablePropType, listReservationItemImmutablePropType$1 as listReservationItemImmutablePropType, locationImmutablePropType$1 as locationImmutablePropType, locationPropType$1 as locationPropType, locationShape$1 as locationShape, loyaltyImmutablePropType$1 as loyaltyImmutablePropType, macroCategoryImmutablePropType$1 as macroCategoryImmutablePropType, macroCategoryShape$1 as macroCategoryShape, mapLocationDataImmutablePropType$1 as mapLocationDataImmutablePropType, packageAttributesImmutablePropType$1 as packageAttributesImmutablePropType, packageAttributesShape$1 as packageAttributesShape, packageCategoriesImmutablePropType$1 as packageCategoriesImmutablePropType, packageCategoryImmutablePropType$1 as packageCategoryImmutablePropType, packageCategoryPropType$1 as packageCategoryPropType, packageCategoryShape$1 as packageCategoryShape, packageImmutablePropType$1 as packageImmutablePropType, packageListImmutablePropType$1 as packageListImmutablePropType, packageShape$1 as packageShape, packagesGroupImmutablePropType$1 as packagesGroupImmutablePropType, packagesGroupShape$1 as packagesGroupShape, postHotelsApiResponseItemsImmutablePropType$1 as postHotelsApiResponseItemsImmutablePropType, pricesImmutablePropType$1 as pricesImmutablePropType, pricesPropType$1 as pricesPropType, pricesShape$1 as pricesShape, reservationItemImmutablePropType$1 as reservationItemImmutablePropType, reservationItemShape$1 as reservationItemShape, reviewImmutablePropType$1 as reviewImmutablePropType, reviewShape$1 as reviewShape, serviceImmutablePropType$1 as serviceImmutablePropType, taxAmountTypePropType$1 as taxAmountTypePropType, taxChargeTypeTypePropType$1 as taxChargeTypeTypePropType, taxItemImmutablePropType$1 as taxItemImmutablePropType, taxTypePropType$1 as taxTypePropType };
